import { render, staticRenderFns } from "./TodaysReturnOfReturnsStatus.vue?vue&type=template&id=c10abe7e&scoped=true&"
import script from "./TodaysReturnOfReturnsStatus.vue?vue&type=script&lang=js&"
export * from "./TodaysReturnOfReturnsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10abe7e",
  null
  
)

export default component.exports